import thanksWomen from "../../../assets/claraViewMedia/thankswomen.png"
import claraviewLogo from "../../../assets/claraViewMedia/landing-page-brand.svg"

const ThanksPage = () => {
    return (
        <div className="h-full flex flex-col font-novatica">
            <div className="h-1/2 ">
                <img src={thanksWomen} alt="" className="w-full h-full object-cover"/>

            </div>
            <div className="h-1/2 text-center flex flex-col relative">
                <h1 className="text-[28px] font-medium text-claraview-tertiary my-3">Confidence in motion</h1>
                <p className="text-claraview-tertiary font-medium text-[16px] mx-6 my-5">Your doctor has received your request for pricing and next steps. You’ll hear from them soon with details designed just for you.</p>
                <img src={claraviewLogo} alt="" className="w-1/2 mx-auto absolute bottom-10 left-1/2 -translate-x-1/2" />
            </div>
        </div>
    )
}

export default ThanksPage